import React from 'react';
import { ArrowRight, Check, UserPlus, Users } from 'lucide-react';
import { BadgeStato, quando } from './stati';

const Persona = ({ d }) => {
  if (d.persona_origine === 'da_scegliere') return <span className="flex items-center gap-1 text-amber-700" data-testid={`haccpok-doc-${d.id}-da-scegliere`}><UserPlus className="h-3 w-3" />Persona da scegliere: finisce negli altri documenti</span>;
  if (!d.persona) return null;
  if (d.persona_origine === 'nuova') return <span className="flex items-center gap-1 text-sky-700"><UserPlus className="h-3 w-3" />{d.persona_app} (nuova persona)</span>;
  if (d.persona_app) return <span className="flex items-center gap-1 text-emerald-700"><Users className="h-3 w-3" />{d.persona_app}{d.persona_origine === 'team' ? ' (team)' : ''}</span>;
  return <span className="text-gray-600">{d.persona}</span>;
};

const Riga = ({ d }) => (
  <div className={`rounded-xl border p-2.5 space-y-1 ${d.gia_importato ? 'border-gray-200 bg-gray-50 opacity-70' : 'border-gray-200 bg-white'}`} data-testid={`haccpok-doc-${d.id}`}>
    <div className="flex items-start justify-between gap-2">
      <p className="text-sm font-medium text-gray-900 min-w-0 break-words">{d.titolo}</p>
      {d.gia_importato
        ? <span className="shrink-0 flex items-center gap-1 text-[11px] font-bold text-gray-500" data-testid={`haccpok-doc-${d.id}-gia`}><Check className="h-3 w-3" />Già copiato</span>
        : d.storico
          ? <span className="shrink-0 px-2 py-0.5 rounded-full text-[11px] font-bold bg-gray-100 text-gray-500" data-testid={`haccpok-doc-${d.id}-storico`}>Storico</span>
          : d.superato
            ? <span className="shrink-0 px-2 py-0.5 rounded-full text-[11px] font-bold bg-gray-100 text-gray-500" data-testid={`haccpok-doc-${d.id}-superato`}>Superato</span>
            : <span className="shrink-0 flex items-center gap-1">
              {d.nuova_versione && <span className="px-2 py-0.5 rounded-full text-[11px] font-bold bg-sky-100 text-sky-800" data-testid={`haccpok-doc-${d.id}-nuova-versione`}>Nuova versione</span>}
              <BadgeStato stato={d.scadenza ? d.stato : 'valido'} testid={`haccpok-doc-${d.id}-stato`} />
            </span>}
    </div>
    <p className="flex items-center gap-1 text-[11px] text-gray-600"><ArrowRight className="h-3 w-3 shrink-0" />{d.nome_tipo}</p>
    <div className="flex flex-wrap gap-x-3 gap-y-0.5 text-[11px]">
      <Persona d={d} />
      <span className="text-gray-500">{quando(d, d.giorni)}{d.scadenza_calcolata ? ' (calcolata)' : ''}</span>
    </div>
  </div>
);

export const ElencoHaccpOk = ({ documenti }) => {
  const sezioni = [...new Set(documenti.map((d) => d.sezione))];
  return (
    <div className="space-y-3 max-h-[52vh] overflow-y-auto pr-1" data-testid="haccpok-elenco">
      {sezioni.map((s) => (
        <div key={s} className="space-y-1.5">
          <h4 className="text-xs font-bold uppercase tracking-wide text-gray-500">{s}</h4>
          {documenti.filter((d) => d.sezione === s).map((d) => <Riga key={d.id} d={d} />)}
        </div>
      ))}
    </div>
  );
};
